// removed by extract-text-webpack-plugin
module.exports = {"content":"PaymentMethodsPage-module__content__1tMNk","desktopTopbar":"PaymentMethodsPage-module__desktopTopbar__M4PKy","mobileTopbar":"PaymentMethodsPage-module__mobileTopbar__3jW3G","title":"PaymentMethodsPage-module__title__1YVtC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PaymentMethodsPage/PaymentMethodsPage.module.css
// module id = 2357
// module chunks = 0